import {Component, Input} from "@angular/core";
import {Channel, ChannelConfig, ProfileConfig, ProfileStateConfig} from "../../../../../model/channels.model";
import {AdminChannelsViewChannelComponent} from "../../view.component";

@Component({
  selector: "admin-channels-view-common-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"]
})
export class AdminChannelViewCommonProfileComponent {

  @Input() default?: ChannelConfig;

  @Input() profile?: ProfileConfig;

  state: ProfileStateConfig = new ProfileStateConfig();

  constructor() {
  }

  get channel() {
    if (this.profile?.channel) {
      return this.profile?.channel!;
    } else {
      let channel = new Channel();
      channel.owner = this.default!.owner!;
      channel.vertical = this.default!.vertical!;
      channel.code = this.default!.code!;
      return channel;
    }
  }

  viewState(state: ProfileStateConfig) {
    console.log(state)
    this.state = state;
  }
}
